import { Weapon, type WeaponConfig } from './Weapon';

const UZI_CONFIG: WeaponConfig = {
  id: 'uzi',
  name: 'Узи',
  // economy W12, calibrated to budget=30+10L. Своп с дробовиком W13: узи дороже
  // (2500 vs 2000), потому что разблокируется позже (L15 vs L10).
  price: 2500,
  fireRateMs: 40,
  bulletsPerShot: 1,
  spreadDeg: 9,
  soundKey: 'pistol_shot',
  soundVolume: 0.25,
  shakeShoot: { intensity: 0.001, duration: 30 },
  magazineSize: 60,
  reloadTimeMs: 2500,
  fireMode: 'auto',
  isDual: true,
  bulletWidth: 4,
  bulletHeight: 2,
  recoilForce: 0.5,
};

export function createUzi(): Weapon {
  return new Weapon(UZI_CONFIG);
}
